import React from "react";

import { makeStyles, fade } from "@material-ui/core/styles";
import { Button, Typography } from "@material-ui/core";

const useStyles = makeStyles((theme) => ({
	root: {
		height: "100%",
		minHeight: 280,
		display: "flex",
		flexDirection: "column",
		alignItems: "center",
		justifyContent: "center",
		textAlign: "center",
		padding: theme.spacing(4),
	},
	iconCircle: {
		width: 72,
		height: 72,
		borderRadius: "50%",
		display: "flex",
		alignItems: "center",
		justifyContent: "center",
		backgroundColor: fade(theme.palette.primary.main, 0.08),
		marginBottom: theme.spacing(2),
		"& svg": {
			fontSize: 34,
			color: theme.palette.primary.main,
		},
	},
	title: {
		fontWeight: 700,
		marginBottom: theme.spacing(0.5),
		color: theme.palette.text.primary,
	},
	message: {
		maxWidth: 420,
		color: (theme.custom && theme.custom.textSecondary) ||
			theme.palette.text.secondary,
		marginBottom: theme.spacing(2.5),
		lineHeight: 1.6,
	},
}));

const EmptyState = ({ icon, title, message, actionLabel, onAction }) => {
	const classes = useStyles();

	return (
		<div className={classes.root}>
			<div className={classes.iconCircle}>{icon}</div>
			<Typography variant="h6" className={classes.title}>
				{title}
			</Typography>
			<Typography variant="body2" className={classes.message}>
				{message}
			</Typography>
			{actionLabel && onAction && (
				<Button variant="contained" color="primary" onClick={onAction}>
					{actionLabel}
				</Button>
			)}
		</div>
	);
};

export default EmptyState;
